// Parses pasted dishes for bulk add.
//
//   ## Les Entrées              section, matched by its title in any language (or its id)
//   ### Houmous Effiloché        dish name (same in every language)
//   TR: ...  EN: ...  FR: ...  ES: ...   descriptions
//
// Markdown decoration (-, *, **) is ignored, so text copied from chat works as is.

import { LANGS, fold } from './model';

const clean = (line) => line.replace(/\*\*/g, '').replace(/^\s*[-*•]\s+/, '').trim();

export const parseBulk = (text, sections) => {
  const findSection = (title) => {
    const t = fold(title);
    return sections.find((s) => fold(s.id) === t || LANGS.some((l) => fold(s.i18n?.[l]?.title) === t));
  };

  const items = [];
  let section = null;
  let sectionLabel = '';
  let cur = null;

  text.split(/\r?\n/).forEach((raw) => {
    const line = clean(raw);
    if (!line || /^-{3,}$/.test(line)) return;
    const h3 = line.match(/^###\s+(.+)/);
    const h2 = !h3 && line.match(/^##\s+(.+)/);
    if (h2) {
      sectionLabel = h2[1].replace(/\(.*\)\s*$/, '').trim();
      section = findSection(sectionLabel);
      cur = null;
      return;
    }
    if (h3) {
      // "### Calamars Frits (Les Entrées)" also sets the section inline.
      let name = h3[1].trim();
      let sec = section;
      let label = sectionLabel;
      const inline = name.match(/^(.*?)\s*\(([^)]+)\)\s*$/);
      if (inline && findSection(inline[2])) {
        name = inline[1];
        label = inline[2];
        sec = findSection(inline[2]);
      }
      cur = { name, section: sec?.id || null, sectionLabel: label, desc: {} };
      items.push(cur);
      return;
    }
    const lang = line.match(/^(TR|EN|FR|ES)\s*:\s*(.*)$/i);
    if (lang && cur) {
      cur.desc[lang[1].toLowerCase()] = lang[2].trim();
    }
  });

  return items.map((it) => {
    const i18n = {};
    LANGS.forEach((l) => { i18n[l] = { name: it.name, description: it.desc[l] || '' }; });
    const problems = [];
    if (!it.section) problems.push(it.sectionLabel ? `Bölüm bulunamadı: "${it.sectionLabel}"` : 'Bölüm yok');
    const missing = LANGS.filter((l) => !it.desc[l]);
    if (missing.length) problems.push(`Açıklama eksik: ${missing.map((l) => l.toUpperCase()).join(', ')}`);
    return { name: it.name, section: it.section, sectionLabel: it.sectionLabel, i18n, problems };
  });
};
